import { Pipe, PipeTransform } from '@angular/core';
import { AddHtmlLineBreaksPipe } from './add-html-line-breaks.pipe.js';
import { AddHtmlLinksPipe } from './add-html-links.pipe.js';
import { ReplaceEmojisPipe } from './replace-emojis.pipe.js';

@Pipe({
	name: 'textToHtml',
	pure: true,
	standalone: false
})
export class TextToHtmlPipe implements PipeTransform {
	transform(text: number | string | null | undefined): string | undefined {
		if (!text) {
			return undefined;
		}

		let transformedText: string | undefined = this.addSpacesToLinkeBreaks(text?.toString());
		transformedText = new AddHtmlLinksPipe().transform(transformedText);
		transformedText = new AddHtmlLineBreaksPipe().transform(transformedText);
		transformedText = new ReplaceEmojisPipe().transform(transformedText);

		return transformedText;
	}

	private addSpacesToLinkeBreaks(text: string): string {
		return text.replace(/<br\s*\/?>/g, ' <br /> ');
	}
}
